export const THEME_SET = "THEME_SET";
export const THEME_TOGGLE = "THEME_TOGGLE";

// localStorage key for the saved theme preference. Centralized so the
// store hydrator and the action creator stay in sync.
export const THEME_STORAGE_KEY = "hadacyTheme";
